import React, { Fragment } from "react";
import { Form, Select, InputNumber } from "antd";
import {
  IconDropDown,
  IconDelete,
  IconCheckboxActive
} from "../../../../common/ui/icons";
import filterConnect from "../../../../common/hoc/filterConnect";

const { Option } = Select;

const AdditionalServices = ({
  form,
  disabled,
  typeForm,
  serviceAdditionals
}) => {
  const { getFieldDecorator, getFieldValue } = form;
  const services = getFieldValue("additionalServices");
  const countSelected = (services && services.length) || 0;
  const getServiceByKey = key => {
    return (
      serviceAdditionals &&
      serviceAdditionals.find(k => key === k.serviceAdditionalKey)
    );
  };
  const total =
    serviceAdditionals &&
    serviceAdditionals.length > 0 &&
    serviceAdditionals
      .map(key => {
        return (
          (getFieldValue(`serviceAdditionalPrice${key.serviceAdditionalKey}`) &&
            parseInt(
              getFieldValue(`serviceAdditionalPrice${key.serviceAdditionalKey}`)
            )) ||
          0
        );
      })
      .reduce((acc, cur) => acc + cur);

  return typeForm === "order" ? (
    <Fragment>
      <div
        className="offer-card__item double-margin"
        style={{ marginBottom: 4 }}
      >
        <span className="label">Дополнительные услуги:</span>
        <Form.Item>
          <div className="multi-select-caption">
            {getFieldDecorator("additionalServices")(
              <Select
                allowClear={true}
                className={
                  countSelected > 0
                    ? "ui-select multi-select selected"
                    : "ui-select multi-select"
                }
                mode="multiple"
                placeholder="Выберите дополнительные услуги"
                dropdownClassName="ui-select__dropdown-multiple"
                menuItemSelectedIcon={<IconCheckboxActive />}
                getPopupContainer={trigger => trigger.parentNode}
                clearIcon={<IconDelete />}
                showArrow={true}
                disabled={disabled}
                suffixIcon={<IconDropDown />}
                style={{ width: 225 }}
              >
                {serviceAdditionals &&
                  serviceAdditionals.map(item => (
                    <Option
                      key={item.serviceAdditionalKey}
                      id={item.serviceAdditionalId}
                      value={item.serviceAdditionalKey}
                    >
                      {item.serviceAdditional}
                    </Option>
                  ))}
              </Select>
            )}
            {getFieldValue("additionalServices") && (
              <span style={{ marginLeft: 16 }}>Итого: {total}</span>
            )}
            {/*<div*/}
            {/*  className={*/}
            {/*    countSelected > 0*/}
            {/*      ? 'selected-caption --selected'*/}
            {/*      : 'selected-caption'*/}
            {/*  }*/}
            {/*>*/}
            {/*  Выбрано {countSelected} доп. услуги*/}
            {/*</div>*/}
          </div>
        </Form.Item>
      </div>
      {serviceAdditionals &&
        countSelected > 0 &&
        services.map(serviceKey => {
          const { serviceAdditionalKey, serviceAdditional } = getServiceByKey(
            serviceKey
          );
          return (
            <div
              key={serviceAdditionalKey}
              className="offer-card__item additional-services"
            >
              <span className="label large">{serviceAdditional}, руб:</span>
              <Form.Item>
                {getFieldDecorator(
                  "serviceAdditionalPrice" + serviceAdditionalKey
                )(
                  <InputNumber
                    style={{ width: 80 }}
                    disabled={disabled}
                    placeholder="Укажите"
                  />
                )}
              </Form.Item>
            </div>
          );
        })}
    </Fragment>
  ) : services ? (
    <Fragment>
      <div
        className="offer-card__item double-margin"
        style={{ marginBottom: 4 }}
      >
        <span className="label">Дополнительные услуги:</span>
        <Form.Item>
          <div className="multi-select-caption">
            {getFieldDecorator("additionalServices")(
              <Select
                allowClear={true}
                className={
                  countSelected > 0
                    ? "ui-select multi-select selected"
                    : "ui-select multi-select"
                }
                mode="multiple"
                placeholder="Выберите дополнительные услуги"
                dropdownClassName="ui-select__dropdown-multiple"
                menuItemSelectedIcon={<IconCheckboxActive />}
                getPopupContainer={trigger => trigger.parentNode}
                clearIcon={<IconDelete />}
                showArrow={true}
                suffixIcon={<IconDropDown />}
                style={{ width: 225 }}
                disabled={disabled}
              >
                {serviceAdditionals &&
                  serviceAdditionals.map(item => (
                    <Option
                      key={item.serviceAdditionalKey}
                      id={item.serviceAdditionalId}
                      value={item.serviceAdditionalKey}
                    >
                      {item.serviceAdditional}
                    </Option>
                  ))}
              </Select>
            )}
            {/*<div*/}
            {/*  className={*/}
            {/*    countSelected > 0*/}
            {/*      ? 'selected-caption --selected'*/}
            {/*      : 'selected-caption'*/}
            {/*  }*/}
            {/*>*/}
            {/*  Выбрано {countSelected} доп. услуги*/}
            {/*</div>*/}
          </div>
        </Form.Item>
      </div>
      {serviceAdditionals &&
        countSelected > 0 &&
        services.map(serviceKey => {
          const { serviceAdditionalKey, serviceAdditional } = getServiceByKey(
            serviceKey
          );
          return (
            <div
              key={serviceAdditionalKey}
              className="offer-card__item additional-services"
              style={{ marginTop: 8 }}
            >
              <span className="label large">{serviceAdditional}, руб:</span>
              <Form.Item>
                {getFieldDecorator(
                  "serviceAdditionalPrice" + serviceAdditionalKey
                )(
                  <InputNumber
                    style={{ width: 80 }}
                    disabled={disabled}
                    placeholder="Укажите"
                  />
                )}
              </Form.Item>
            </div>
          );
        })}
    </Fragment>
  ) : null;
};

export default filterConnect(AdditionalServices, ["serviceAdditionals"]);
